import { useSuspenseQueries } from '@tanstack/react-query'
import { integrationQueryOptions } from '../../queries'

export function useIntegrations({ integrationIds, workspaceId }: { integrationIds: string[]; workspaceId: string }) {
  return useSuspenseQueries({
    queries: integrationIds.map((integrationId) => integrationQueryOptions({ integrationId, workspaceId })),
    combine: (results) => results.map((result) => result.data),
  })
}
